import Vue from 'vue'
import VueRouter from 'vue-router'

import LanguageRouter from '@/extensions/languageRouter'
import { Home, About, ArtificialIntelligence, Projects, Documents, News, Article, NotFound } from '@/views'

Vue.use(VueRouter)
Vue.use(LanguageRouter)

const routes = LanguageRouter.createRoutes('fr', 'en')(
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: { en: '/about', fr: '/a-propos' },
    name: 'about',
    component: About
  },
  {
    path: { en: '/artificial-intelligence', fr: '/intelligence-artificielle' },
    name: 'ai',
    component: ArtificialIntelligence
  },
  {
    path: { en: '/projects', fr: '/projets' },
    name: 'projects',
    component: Projects
  },
  {
    path: '/documents',
    name: 'documents',
    component: Documents
  },
  {
    path: { en: '/news/:category?', fr: '/nouvelles/:category?' },
    name: 'news',
    component: News,
    props: true
  },
  {
    path: { en: '/news/:category/:articleSlug', fr: '/nouvelles/:category/:articleSlug' },
    name: 'article',
    component: Article,
    props: true
  },
  {
    path: '/404',
    name: 'not-found',
    component: NotFound
  },
  {
    path: '*',
    name: 'catch-all',
    component: NotFound
  }
)

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: '-active',
  routes
})
